import { $teams } from "./states";
import { fetchTeams } from "./effects";

// Fetch teams
$teams.on(fetchTeams.doneData, (_, data) => data);
